import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import sampleResponses from "static-data/sample-responses";
import sampleRequests from "static-data/sample-requests";
import FundApprocalDark from "../assets/fund-approval-flow.svg";
import FundApprocalLight from "../assets/fund-approval-flow-light.svg";
import FundingProcessDark from "../assets/funding-process.svg";
import FundingProcessLight from "../assets/funding-process-light.svg";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";
import MDButton from "components/MDButton";
import { ContentCopy } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import DocImage from "components/DocImage";

const ApiDescription = ({ data, search }) => {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      } else {
        return (
          childVal?.parentHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeading
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDesc
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescStatic
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.mainHeadingDescStaticTwo
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ||
          childVal?.endPointDesc?.toLowerCase()?.includes(search.toLowerCase())
        );
      }
    });
  };
  const filtered = filter();
  const themeMode = darkMode ? "dark-tbl" : "light-tbl";

  return (
    <>
      {filtered.length === 0 && (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      )}
      {filtered.length > 0 &&
        filtered.map((childVal) => {
          return (
            <>
              {childVal.mainGridIdStatic && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  key={childVal.mainGridIdStatic}
                  id={childVal.mainGridIdStatic}
                >
                  {childVal.mainHeadingStatic && (
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStatic && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStatic}
                    </MDTypography>
                  )}
                  {childVal?.email && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      display="block"
                      width="100%"
                    >
                      {childVal?.email?.map((item) => {
                        return (
                          <>
                            <a href={"mailto:" + item}>{item}</a>
                            <br />
                          </>
                        );
                      })}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStaticTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      {childVal.mainHeadingDescStaticTwo}
                    </MDTypography>
                  )}
                  {childVal.diagramOneLabel && (
                    <>
                      <DocImage
                        src={darkMode ? FundApprocalDark : FundApprocalLight}
                        className="center-img"
                        alt={childVal.diagramOneLabel}
                      />
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        textAlign="center"
                        lineHeight={2}
                        display="block"
                        marginBottom="25px"
                        width="100%"
                      >
                        <i className="text-center d-block">
                          {childVal?.diagramOneLabel}
                        </i>
                      </MDTypography>
                      {childVal.mainHeadingDescStaticTwo && (
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          display="block"
                        >
                          {childVal.mainHeadingDescStaticTwo}
                        </MDTypography>
                      )}
                    </>
                  )}
                  {childVal.diagramTwoLabel && (
                    <>
                      <DocImage
                        src={
                          darkMode ? FundingProcessDark : FundingProcessLight
                        }
                        className="center-img"
                        alt={childVal.diagramTwoLabel}
                      />
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        textAlign="center"
                        lineHeight={2}
                        display="block"
                        marginBottom="25px"
                        width="100%"
                      >
                        <i className="text-center d-block">
                          {childVal?.diagramTwoLabel}
                        </i>
                      </MDTypography>
                    </>
                  )}
                </Grid>
              )}
              {childVal.parentHeading && (
                <MDTypography
                  variant="h4"
                  fontWeight="bold"
                  fontFamily="inherit"
                  lineHeight={2}
                  id={childVal.parentId ? childVal.parentId : ""}
                  className="section"
                >
                  {childVal.parentHeading}
                </MDTypography>
              )}
              {childVal.mainHeading && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  key={childVal.mainGridId}
                  id={childVal.mainGridId}
                >
                  <Grid
                    item
                    xs={12}
                    md={8}
                    pr={2}
                    id={childVal.mainGridId}
                    className={
                      childVal.mainHeading ===
                      "Get Access to External API Fund Request"
                        ? "no-sticky section"
                        : "section"
                    }
                  >
                    {childVal.mainHeading && (
                      <MDTypography
                        variant={childVal?.parentId ? "h5" : "h4"}
                        fontWeight="bold"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={
                          childVal.accessTokenId ? childVal.accessTokenId : ""
                        }
                        className="section"
                      >
                        {childVal.mainHeading}
                      </MDTypography>
                    )}
                    {childVal.mainHeadingDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.endpointId && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.endpointId ? childVal.endpointId : ""}
                        className="section"
                      >
                        {childVal.endPointHeading}
                      </MDTypography>
                    )}
                    {childVal.endPointMethod && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.endPointNote && (
                      <>
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal.endPointNote}
                          </MDTypography>
                        </p>
                        <br />
                      </>
                    )}
                    {childVal.endPointDesc2 && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc2 && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc2}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc2)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.requestHeader && (
                      <>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          mt={3}
                          lineHeight={2}
                          id={childVal.requestHeaderId}
                          className="section"
                        >
                          {childVal.requestHeader}
                        </MDTypography>
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns: childVal.requestHeaderTable.columns,
                                  rows: childVal.requestHeaderTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                        {childVal.requestHeaderNote && (
                          <p>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              {childVal.requestHeaderNote}
                            </MDTypography>
                          </p>
                        )}
                      </>
                    )}

                    {childVal.requestBody && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        mt={3}
                        lineHeight={2}
                        id={
                          childVal.requestBodyId ? childVal.requestBodyId : ""
                        }
                        className="section"
                      >
                        {childVal.requestBody}
                      </MDTypography>
                    )}
                    {childVal.requestBodyDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.requestBodyDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.statusCodeCreated && (
                      <p className="staus-code created">
                        {childVal.statusCodeCreated}
                      </p>
                    )}
                    {childVal.requestBodyTable && (
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.requestBodyTable.columns,
                                rows: childVal.requestBodyTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.requestBodyImage && (
                      <DocImage
                        src={childVal.requestBodyImage}
                        className="center-img section"
                        id={childVal.requestBodyImageId}
                        alt="Response Header"
                      />
                    )}
                  </Grid>

                  {childVal.reqObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Request Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleRequests.funding[childVal.reqObjKey].trim()}
                      />
                    </Grid>
                  )}

                  {childVal.respBody && (
                    <Grid item xs={12} md={8} pr={2}>
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.respBodyId}
                        className="section"
                      >
                        {childVal.respBody}
                      </MDTypography>
                      {childVal.respBodyStatusCodeSuccess && (
                        <p className="staus-code code-success">
                          {childVal.respBodyStatusCodeSuccess}
                        </p>
                      )}
                      {childVal.respBodyImg && (
                        <DocImage
                          src={childVal.respBodyImg}
                          className="center-img"
                          alt="Response Body"
                        />
                      )}
                      {childVal.respBodyImg2 && (
                        <DocImage
                          src={childVal.respBodyImg2}
                          className="center-img"
                          alt="Response Body 2"
                        />
                      )}
                      {childVal.respBodyDesc && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal.respBodyDesc}
                          </MDTypography>
                        </p>
                      )}
                      {childVal.respBodySuccess && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                            id={childVal.respBodySuccessId}
                            className="section"
                          >
                            <b>Success: </b>
                            {childVal.respBodySuccess}
                          </MDTypography>
                        </p>
                      )}
                      {childVal.successApiResponseObj && (
                        <HighlightedCode
                          code={sampleResponses.funding[
                            childVal.successApiResponseObj
                          ].trim()}
                          enableNumbering={true}
                        />
                      )}
                      {childVal.respBodySuccessTableTwo && (
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns:
                                    childVal.respBodySuccessTableTwo.columns,
                                  rows: childVal.respBodySuccessTableTwo.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      )}
                      {childVal.respBodySuccessTable && (
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns:
                                    childVal.respBodySuccessTable.columns,
                                  rows: childVal.respBodySuccessTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      )}
                    </Grid>
                  )}

                  {childVal.respObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Response Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses.funding[
                          childVal.respObjKey
                        ].trim()}
                      />
                    </Grid>
                  )}

                  {childVal.respBodyValidationTableTwo && (
                    <Grid item xs={12} md={8} pr={2}>
                      <p className="mt-5">
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id={childVal.respBodyValidationId}
                          className="section"
                        >
                          <b>Validation: </b>
                          {childVal.respBodyValidation}
                        </MDTypography>{" "}
                      </p>
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns:
                                  childVal.respBodyValidationTableTwo.columns,
                                rows: childVal.respBodyValidationTableTwo.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    </Grid>
                  )}
                  {childVal.respBodyValidationTable && (
                    <Grid item xs={12} md={8} pr={2}>
                      <p className="mt-5">
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id={childVal.respBodyValidationId}
                          className="section"
                        >
                          <b>Validation: </b>
                          {childVal.respBodyValidation}
                        </MDTypography>{" "}
                      </p>
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns:
                                  childVal.respBodyValidationTable.columns,
                                rows: childVal.respBodyValidationTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    </Grid>
                  )}
                  {childVal.respValidationObjKey && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Validation
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses.funding[
                          childVal.respValidationObjKey
                        ].trim()}
                      />
                    </Grid>
                  )}
                </Grid>
              )}
            </>
          );
        })}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
